import "./QrCodeModal.scss";
import React, { useEffect, useState } from "react";
import { Plugins } from "@capacitor/core";
import { SocialSharing } from "@ionic-native/social-sharing";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useTracked } from "../../state";
import qr from "qr-image";
import { chevronBack, copyOutline } from "ionicons/icons";
import { ShowToastSuccessMessage } from "../../utils/helpers/ToastMessage";

const { Device, Clipboard } = Plugins;

interface Props {
  isOpen: boolean;
  setIsOpen: Function;
}

const QrCodeModal: React.FC<Props> = ({ isOpen, setIsOpen }) => {
  const [state] = useTracked();
  const [qrCode, setQrCode] = useState<any>(null);

  const getImageDataURI = (data: any) => {
    let pngBuffer = qr.imageSync(data, { type: "png" });
    return "data:image/png;base64," + pngBuffer.toString("base64");
  };

  useEffect(() => {
    if (state.identity) {
      let tempQrCode: any = getImageDataURI(state.identity || "anonymous");
      setQrCode(tempQrCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.identity]);

  const handleShare = async () => {
    const { platform } = await Device.getInfo();

    if (platform === "ios" || platform === "android") {
      if (qrCode) {
        await SocialSharing.share("", "Abaxx QR Code", qrCode, "");
      }
    }
  };

  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={() => setIsOpen(false)}
      className="qrcode-modal"
      backdropDismiss={true}
    >
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton className="btn-back" onClick={() => setIsOpen(false)}>
              <IonIcon icon={chevronBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Your Wallet Address</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="no-scroll">
        <div className="qr-container">
          <img src={qrCode} className="qr-code" width="100" alt="qr" />
        </div>
        <div className="wa-container">
          <span>
            {state.identity}
            <span>
              <IonButton
                fill="clear"
                size="small"
                onClick={() => {
                  Clipboard.write({ string: state.identity });
                  ShowToastSuccessMessage("Wallet Address copied to clipboard");
                }}
              >
                <IonIcon icon={copyOutline} slot="start" color="medium" />
              </IonButton>
            </span>
          </span>
        </div>
      </IonContent>
      <IonFooter>
        <IonButton
          color="danger"
          expand="block"
          shape="round"
          onClick={handleShare}
        >
          Share
        </IonButton>
      </IonFooter>
    </IonModal>
  );
};

export default QrCodeModal;
